var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.9749 16.3599C15.9749 16.8519 15.6449 17.1799 15.1499 17.1799H5.24993C4.75493 17.1799 4.42493 16.8519 4.42493 16.3599V3.23992C4.42493 2.74792 4.75493 2.41992 5.24993 2.41992H11.5199L15.9749 6.84792V16.3599Z",
    fill: "#9D60FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07507 14.7202L8.13757 12.0142L9.37507 13.6542L11.4376 10.9482L14.3251 14.7202H6.07507Z",
    fill: "#9D60FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 17.9996H5.24998C4.34248 17.9996 3.59998 17.2616 3.59998 16.3596V3.23961C3.59998 2.33761 4.34248 1.59961 5.24998 1.59961H11.85L16.8 6.51961V16.3596C16.8 17.2616 16.0575 17.9996 15.15 17.9996ZM5.24998 3.23961V16.3596H15.15V7.17561L11.19 3.23961H5.24998Z",
    fill: "#9D60FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 7.34008H11.025V2.83008L15.5625 7.34008Z",
    fill: "#9D60FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.22fc9d233dfafcaaa82e70f5330f9423.svg";
export { ForwardRef as ReactComponent };